import { makeStateStore } from '@playcastdotio/StateStore';
import type { PlaycastMessageSystemSignMachineIdPayloadReply } from '@playcastdotio/Messaging';

type SignMachineIdPayloadReply = PlaycastMessageSystemSignMachineIdPayloadReply['message'];

/**
 * Mailbox for Playjector signMachineIdPayload replies (AIK signatures).
 * Kept out of shared.ts so sign helpers do not pull GlobalConfig at import time.
 */
export const signMachineIdPayloadReplyState = makeStateStore<SignMachineIdPayloadReply | null>(null, {
  replicate: { channel: 'signMachineIdPayloadReplyState', targets: ['remoteClient'] },
});
